import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { socket } from 'api';
import { notify, cloneDeep } from 'libs/common';
import { BlueButton, Toggle, Loader } from 'libs/ui';
import { Schedule } from './schedule/schedule';
import { Wrapper, Content, Buttons } from './options.styled';

const weekdays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
let itemsOld = [];
let manualModeOld = true;

export const ScheduleOptions = ({ id }) => {
  const { t } = useTranslation();
  const status = useSelector((store) => store.equipment[id] ?? {});
  const { mode } = status;
  const offline = mode === 'offline';
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState(itemsOld);
  const [manualMode, setManualMode] = useState(manualModeOld);

  let cl2 = offline || !mode ? 'offline1' : '';

  useEffect(() => {
    const initData = (data) => {
      // console.log("data", data);
      if (data.manual_mode === undefined) {
        data.manual_mode = true;
      }
      if (data.items === undefined) {
        data.items = [];
      }
      itemsOld = cloneDeep(data.items);
      manualModeOld = data.manual_mode;
      setItems(data.items);
      setManualMode(data.manual_mode);
      setReady(true);
    };

    const updated = () => {
      setReady(true);
      setLoading(false);
      notify(t('windows.Внимание'), t('messages.Изменения сохранены'), 'success');
    };

    socket.on('racks.get_schedule_of_modes', initData);
    socket.on('racks.set_schedule_of_modes', updated);
    socket.call('racks.get_schedule_of_modes', { target: id });
    return () => {
      // setData(null);
      setReady(false);
      socket.off('racks.get_schedule_of_modes', initData);
      socket.off('racks.set_schedule_of_modes', updated);
    };
  }, []);

  /**
   * save manual mode on change
   */
  useEffect(() => {
    const saveMode = () => {
      setReady(false);
      const out = {
        target: id,
        manual_mode: manualMode,
        items: itemsOld,
      };

      socket.call('racks.set_schedule_of_modes', out);
      manualModeOld = manualMode;
    };

    if (manualModeOld !== manualMode) {
      saveMode();
    }
  }, [manualMode]);

  /**
   * change manual mode
   * @param {*} event
   */
  const changeManualMode = (event) => {
    setManualMode(!event.target.checked);
  };

  const checkListValid = () => {
    const out = [];
    const tmp = {};
    const tmp1 = {};
    let emptyError = false;
    items.forEach((el) => {
      let idx = 0;
      let val = el.weekdays;
      if (val > 0) {
        while (val > 0) {
          if (!!(val & 1)) {
            const key = weekdays[idx];
            if (!tmp[key]) {
              tmp[key] = {};
            }
            if (tmp[key][el.time_at]) {
              out.push(key);
            }
            tmp[key][el.time_at] = 1;
          }
          val = val >> 1;
          idx++;
        }
      } else {
        const key = 0;
        if (!tmp1[key]) {
          tmp1[key] = {};
        }
        if (tmp1[key][el.time_at]) {
          emptyError = true;
        }
        tmp1[key][el.time_at] = 1;
      }
    });

    if (emptyError) {
      notify(
        t('windows.Внимание'),
        t('errors.Не удалось сохранить Обнаружены пересечения в расписании') + t('errors.Устраните пересечения, для успешного сохранения'),
        'danger',
        6000
      );
      return false;
    }
    if (out.length > 0) {
      const days = out.join(', ');
      notify(
        t('windows.Внимание'),
        t('errors.Не удалось сохранить Обнаружены пересечения в расписании на дни') +
          ' ' +
          days +
          '. ' +
          t('errors.Устраните пересечения, для успешного сохранения'),
        'danger',
        6000
      );
      return false;
    }
    return true;
  };

  /**
   * save
   */
  const save = () => {
    const valid = checkListValid();
    if (!valid) {
      return;
    }

    setLoading(true);

    const out = {
      target: id,
      manual_mode: manualMode,
      items,
    };

    socket.call('racks.set_schedule_of_modes', out);
    itemsOld = cloneDeep(items);
    manualModeOld = manualMode;
  };

  const changeData = (out) => {
    // console.log('out', out);
    setItems(out);
    // setNextrender((val) => val + 1);
  };

  // changes
  const nochanges = useMemo(() => JSON.stringify(items) !== JSON.stringify(itemsOld), [items, itemsOld]);

  if (!ready) {
    return (
      <Wrapper>
        <Content className={cl2}>
          <Loader />
        </Content>
      </Wrapper>
    );
  }

  const cl = loading ? 'loading' : '';

  return (
    <Wrapper>
      <Content className={cl2}>
        <Toggle
          label={t('windows.Ручной режим')}
          label2={t('windows.Режим работы по расписанию')}
          setOne={() => setManualMode(true)}
          setTwo={() => setManualMode(false)}
          name="manual_mode"
          checked={!manualMode}
          onChange={changeManualMode}
        />

        <Schedule data={items} onChange={changeData} />

        <Buttons>
          <BlueButton onClick={save} className={cl} disabled={!nochanges}>
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </BlueButton>
        </Buttons>
      </Content>
    </Wrapper>
  );
};
